<!--
  app/components/pages/how-to-play/HtpIconChrono.vue
-->
<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    number: string;
    width?: number;
    height?: number;
  }>(),
  { width: 52, height: 59 }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 135 153"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.99184 85.7694C7.99184 53.1752 34.4147 26.7526 67.0087 26.7526C84.6766 26.7526 100.528 34.5184 111.344 46.8202L117.142 41.3067C104.867 27.4761 86.9556 18.7605 67.0087 18.7605C30.0008 18.7605 0 48.7616 0 85.7694C0 104.506 7.69003 121.445 20.0855 133.605L25.8832 128.092C14.8496 117.369 7.99184 102.371 7.99184 85.7694Z"
      fill="currentColor"
    />
    <path
      d="M117.143 41.3057L111.345 46.8192C120.483 57.2123 126.026 70.8421 126.026 85.7684C126.026 118.363 99.6036 144.785 67.0094 144.785C51.0169 144.785 36.5128 138.421 25.8839 128.091L20.0862 133.604C32.1745 145.464 48.7376 152.777 67.0094 152.777C104.017 152.777 134.018 122.776 134.018 85.7684C134.018 68.7072 127.642 53.1355 117.143 41.3057Z"
      fill="currentColor"
      fill-opacity="0.47"
    />
    <rect x="51.4771" width="29.8278" height="18.0088" rx="7.2035" fill="currentColor" />
    <path
      d="M29.0188 26.82L16.3838 35.4989C15.2965 36.2457 13.7962 35.9672 13.0492 34.8801L8.58142 28.3756C7.83466 27.2883 8.11311 25.7878 9.20023 25.041L21.8352 16.3621C22.9223 15.6154 24.4228 15.8938 25.1696 16.9809L29.6376 23.4856C30.3843 24.5727 30.1059 26.0732 29.0188 26.82Z"
      fill="currentColor"
    />
    <path
      d="M115.962 34.8132L104.582 26.3175C103.277 25.343 103.006 23.4777 103.981 22.1725L108.027 16.7522C109.002 15.4469 110.867 15.1763 112.172 16.1506L123.552 24.6465C124.858 25.6208 125.128 27.4861 124.154 28.7914L120.107 34.2116C119.133 35.5169 117.268 35.7877 115.962 34.8132Z"
      fill="currentColor"
    />
    <text
      x="67"
      y="108"
      text-anchor="middle"
      font-family="KingsFont, Arial, sans-serif"
      font-size="52"
      font-weight="700"
      fill="currentColor"
    >
      {{ props.number }}
    </text>
  </svg>
</template>
